import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import celebrityService from '../../services';
import GlassCard from '../ui/GlassCard';
import './CompaniesList.css';

const CompaniesList = () => {
  const navigate = useNavigate();
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchCompanies();
  }, []);

  const fetchCompanies = async () => {
    try {
      setLoading(true);
      const data = await celebrityService.getAllCompanies();
      setCompanies(data);
    } catch (err) {
      setError('Failed to load companies');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleCompanyClick = (companyId) => {
    navigate(`/company/${companyId}`);
  };

  const formatNumber = (num) => {
    if (num >= 1000000000) return `$${(num / 1000000000).toFixed(1)}B`;
    if (num >= 1000000) return `$${(num / 1000000).toFixed(0)}M`;
    if (num >= 1000) return `$${(num / 1000).toFixed(0)}K`;
    return `$${num}`;
  };

  if (loading) {
    return <div className="companies-loading">Loading companies...</div>;
  }

  if (error) {
    return <div className="companies-error">{error}</div>;
  }

  return (
    <div className="companies-container">
      <div className="companies-header">
        <h1>Portfolio Companies</h1>
        <p className="companies-subtitle">
          Discover companies backed by celebrity investors
        </p>
      </div>

      <div className="companies-grid">
        {companies.map((company) => (
          <GlassCard
            key={company.company_id}
            className="company-card"
            onClick={() => handleCompanyClick(company.company_id)}
          >
            <div className="company-card-header">
              <h3 className="company-name">{company.name}</h3>
              <span className={`company-status ${company.status.toLowerCase()}`}>
                {company.status}
              </span>
            </div>

            <p className="company-industry">{company.industry}</p>
            
            <div className="company-metrics">
              <div className="metric">
                <span className="metric-label">Founded</span>
                <span className="metric-value">{company.founded}</span>
              </div>
              <div className="metric">
                <span className="metric-label">Latest Round</span>
                <span className="metric-value">
                  {company.latest_funding?.round_type || 'N/A'}
                </span>
              </div>
              <div className="metric">
                <span className="metric-label">Valuation</span>
                <span className="metric-value">
                  {company.latest_funding ? 
                    formatNumber(company.latest_funding.valuation || company.latest_funding.market_cap) : 
                    'N/A'}
                </span>
              </div>
            </div>

            <div className="company-investors">
              <span className="investors-label">Celebrity Investors:</span>
              <div className="investors-list">
                {company.celebrity_investors.slice(0, 2).map((investor, idx) => (
                  <span key={idx} className="investor-name">{investor}</span>
                ))}
                {company.celebrity_investors.length > 2 && (
                  <span className="investor-more">
                    +{company.celebrity_investors.length - 2} more
                  </span>
                )}
              </div>
            </div>
          </GlassCard>
        ))}
      </div>
    </div>
  );
};

export default CompaniesList;